import { useState, useEffect } from "react";

const useSubTask = (taskGuid, task) => {
    const localStorageKey = `subTasksState_${taskGuid}`;

    // Betöltjük az előző állapotot a localStorage-ból
    const [subTaskState, setSubTaskState] = useState(() => {
        const savedState = localStorage.getItem(localStorageKey);
        return savedState ? JSON.parse(savedState) : {};
    });

    const [allSubTasksOpen, setAllSubTasksOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem(localStorageKey, JSON.stringify(subTaskState));
    }, [subTaskState]);

    // Egyéni alfeladat állapotának váltása
    const toggleSubTask = (subTaskId) => {
        setSubTaskState(prevState => ({
            ...prevState,
            [subTaskId]: !prevState[subTaskId]
        }));
    };

    // Összes alfeladat állapotának váltása
    const toggleAllSubTasks = () => {
        const newState = !allSubTasksOpen;
        setAllSubTasksOpen(newState);
    
        const updatedState = {};
        (task.sub_tasks || []).forEach(sub => {
            updatedState[sub.id] = newState;
        });
    
        setSubTaskState(updatedState);
    };

    return {
        subTaskState,
        toggleSubTask,
        toggleAllSubTasks,
        allSubTasksOpen
    };
};

export default useSubTask;